<template>
  <div
    class="product-item shadow"
    :class="{ active: isActive, detailPopup: isDetailPopup }"
    :data-productid="item.PRODUCT_ID"
    @mouseenter="isLandscape && (scrollable = true)"
    @mouseleave="isLandscape && (scrollable = false)"
    @touchstart="!isLandscape && (scrollable = true)"
    @touchend="!isLandscape && (scrollable = false)"
    @contextmenu.prevent
    @selectstart.prevent
  >
    <div v-if="isExtraRatioShow()" class="product-tag">
      <div class="product-tag-ani">
        <img v-for="(item, index) in fireTagAni" :key="index" :src="item" />
      </div>
      <img v-if="bonusIcon" class="product-tag-bonus" :src="bonusIcon" />
      <span class="product-tag-ratio">+{{ extraRatio() }}</span>
    </div>
    <div class="product-item-detail" @click="showDetailPopup(item)">
      <div
        v-if="showFirstPayIcon"
        class="product-item-detail-first"
        :style="firstPayIcon"
      >
        <p
          class="product-item-detail-first-text"
          :style="newFirstPayTextStyle"
          v-html="showText"
        ></p>
      </div>
      <gift-icon
        :background="getGiftBanckground(item)"
        :gifts="getGiftIcons(item)"
        :enable3d="scrollable"
      ></gift-icon>
      <product-info
        :productName="getProductName(item)"
        :productDetail="getProductDetail(item)"
        @showLoginPopup="showLoginPopup"
        @selectProduct="selectProduct"
        @clickAddToCart="clickAddToCart"
        :price="item.GAME_AMOUNT"
        :item="item"
        :scrollable="scrollable"
      ></product-info>
    </div>
    <PopupWindow
      v-if="visibleInterceptPopup"
      type="tips"
      :languages="letter"
      :title="interceptTitle"
      :content="interceptTip"
      :confirm="interceptConfirm"
      textAlign="center"
      @onConfirm="hideInterceptPopup"
      @onCancel="hideInterceptPopup"
    ></PopupWindow>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import ProductInfo from '@components/officialTopupNew/product/ProductInfo.vue';

import cartAddAndDetail from '@mixins/officialTopupNew/cartAddAndDetail';
import product from '@mixins/officialTopupNew/product';
import productName from '@mixins/product';
import { clickButton, locationType } from '@plugins/biPoint/_configWebstoreV35';
import firstPayNewImage from '@assets/image/officialTopupNew/common/firstPayNew.png';
import ruProductIntercept from '@mixins/officialTopupNew/ruProductIntercept';

export default {
  name: 'ProductItem',
  mixins: [product, productName, cartAddAndDetail, ruProductIntercept],
  props: ['item', 'selectItem', 'isPreProduct', 'isDetailPopup'],
  data() {
    return {
      scrollable: false
    };
  },
  computed: {
    ...mapState({
      isLandscape: state => state.page.isLandscape,
      gameId: state => state.gameId,
      letter: state => state.letter,
      currency: state => state.showCurrency,
      picList: state => state.page.picList,
      isLogin: state => state.login.isLogin,
      curLocation: state => state.curLocation,
      lang: state => state.lang
    }),
    ...mapGetters(['isJpPlatform', 'gameInfoConfig']),
    fireTagAni() {
      return [
        this.picList.fireTag1,
        this.picList.fireTag2,
        this.picList.fireTag3,
        this.picList.fireTag4
      ];
    },
    firstPayIcon() {
      return `background-image: url(${
        this.picList.firstPayNew || firstPayNewImage
      })`;
    },
    newFirstPayTextStyle() {
      if (this.letter.v3FirstTopUpGiveaway.length >= 18) {
        return `font-size: 14px;`;
      } else if (this.letter.v3FirstTopUpGiveaway.length >= 10) {
        return `font-size: 16px;`;
      } else {
        return `font-size: 18px;`;
      }
    },
    isActive() {
      if (this.isPreProduct || this.isDetailPopup) {
        return false;
      }
      return (
        this.item.PRODUCT_ID == this.selectItem.PRODUCT_ID &&
        this.item.CP_PRODUCT_ID == this.selectItem.CP_PRODUCT_ID
      );
    },
    bonusIcon() {
      return this.picList?.bonus || '';
    },
    showFirstPayIcon() {
      return this.item.PRODUCT_EXTRA_COIN && +this.item.PRODUCT_EXTRA_COIN > 0;
    },
    showText() {
      if (+this.gameId == 386) {
        const tips = {
          firstPay: {
            'zh-CN': '首充送$num\n星石',
            'zh-TW': '首次儲值贈送\n$num星石',
            'en-US': 'First Top-up Bonus:\n$num Star Stones'
          }
        };
        const text = tips['firstPay'][this.lang] || tips['firstPay']['en-US'];
        return text.replace('$num', this.item.PRODUCT_EXTRA_COIN);
      }
      return this.letter.v3FirstTopUpGiveaway;
    }
  },
  methods: {
    isExtraRatioShow() {
      if (
        this.gameInfoConfig?.hideExtraCoinIcon?.includes?.(this.curLocation) ||
        !this.curLocation
      ) {
        return false;
      }
      return this.extraRatio() !== '0%';
    },
    extraRatio() {
      if (!this.item.EXTRA_RATIO) return '0%';
      return (parseFloat(this.item.EXTRA_RATIO) * 100).toFixed(0) + '%';
    },
    showLoginPopup() {
      this.$emit('showLoginPopup');
    },
    selectProduct(item) {
      if (this.handleProductIntercept(item)) {
        this.$emit('selectProduct', item);
      }
    },
    clickAddToCart(item, animateAddToCart) {
      if (this.handleProductIntercept(item)) {
        this.$emit('clickAddToCart', item, animateAddToCart);
      }
    },
    showDetailPopup(item) {
      if (this.isLogin) {
        if (this.handleProductIntercept(item)) {
          this.$emit('showDetailPopup', {
            ...item,
            showBtn: !this.isPreProduct
          });
        }
      } else {
        this.$emit('showLoginPopup');
      }
      clickButton({
        btnName: 'confirm_product',
        locationKey: locationType.selectProduct
      });
    }
  },
  components: {
    ProductInfo
  }
};
</script>

<style scoped lang="scss">
@import '@assets/scss/officialTopupNew/officialTopupNew.scss';
@import '@assets/scss/officialTopupNew/_dimen.scss';

@keyframes fireTagAni {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-100%);
  }
}

@keyframes fireTagAniRtl {
  0% {
    transform: scaleX(-1) translateX(0);
  }
  100% {
    transform: scaleX(-1) translateX(-100%);
  }
}

.product-item {
  // overflow: hidden;
  position: relative;
  box-sizing: border-box;
  // width: 315px;
  width: calc(50% - 10px);

  -webkit-touch-callout: none; /* iOS 禁止长按弹出菜单 */
  -webkit-user-select: none;
  user-select: none;

  margin-bottom: 30px;
  background: #fff;
  border-radius: 10px;
  cursor: pointer;

  &.detailPopup {
    border: unset;
    width: 100%;
    margin-bottom: 0;
    .choose {
      display: none;
    }
  }
  .product-tag {
    overflow: hidden;
    z-index: 3;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 10px;
    top: 10px;
    width: 149px;
    height: 50px;
    padding: 0 20px;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    font-size: 20px;
    color: #333333;
    pointer-events: none;
    user-select: none;

    &-ani {
      overflow: hidden;
      position: absolute;
      top: 0;
      left: 0;
      width: 400%;
      height: 100%;
      display: flex;
      flex-wrap: nowrap;
      will-change: transform;
      backface-visibility: hidden;
      transform: translateZ(0);
      animation-fill-mode: both;
      img {
        width: 25%;
        height: 100%;
        object-fit: contain;
        image-rendering: -webkit-optimize-contrast;
        image-rendering: crisp-edges;
      }
    }

    &-bonus {
      position: absolute;
      top: 18px;
      left: 11px;
      margin: auto;
      width: 24px;
      height: 24px;
      object-fit: contain;
    }

    &-ratio {
      position: absolute;
      top: 24px;
      left: 64px;
      font-size: 18px;
      font-weight: bold;
    }
  }
  &-detail {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;

    &-first {
      z-index: 2;
      position: absolute;
      top: -14px;
      right: -14px;
      width: 97px;
      height: 97px;
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;

      &-text {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 90%;
        height: 90%;
        font-size: 18px;
        font-weight: bold;
        line-height: 1.2;
        text-align: center;
        color: #fff;
        white-space: pre-wrap;
      }
    }

    .product-name {
      font-size: 22px;
      color: $commodityNameColor;
      margin-bottom: 5px;
      font-weight: normal;
    }

    .product-price {
      font-size: 28px;
      color: $themeColor;
      font-weight: bold;
    }
    .double-tip {
      display: flex;
      align-items: center;
      font-size: 20px;
      color: $commodityNameColor;
      .double-ico {
        display: inline-block;
        width: 20px;
        height: 20px;
        margin-left: 5px;
      }
    }
  }
  .choose {
    display: block;
    position: absolute;
    right: 3px;
    bottom: 3px;
    font-size: 27px;
    color: #dddddd;
    &.active {
      color: $themeColor;
    }
  }
}

::v-deep .icon-container {
  padding-top: 30px;
  background-size: 105%;
  background-position: center;
}

.product-item {
  transition: box-shadow 0.3s ease;
  &:hover,
  &:active {
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.8);

    .product-tag-ani {
      animation: fireTagAni 0.8s steps(4, end) infinite;
      transform: translateZ(0);
    }
  }
}

[dir='rtl'] {
  .product-item {
    .product-tag-ani {
      transform: scaleX(-1);
    }

    &:hover,
    &:active {
      .product-tag-ani {
        animation: fireTagAniRtl 0.8s steps(4, end) infinite;
      }
    }
  }
}

#ssr-page.landscape {
  .product-item {
    width: 296px;
    margin-right: 20px;
    .product-tag {
      font-size: 20px;

      .ico {
        display: inline-block;
        background-size: cover;
        width: 18px;
        height: 15px;
      }
    }
    &-detail {
      .product-name {
        font-size: 18px;
        margin-bottom: 13px;
      }

      .product-price {
        font-size: 22px;
      }
      .double-tip {
        font-size: 16px;
      }
    }
    .choose {
      font-size: 23px;
    }
  }

  ::v-deep .icon-container {
    padding-top: 40px;
  }
}
</style>
